<template>
    <div id="editCaseWorker">
        <v-container class="pa-0">
            <v-layout>
                <v-flex class="xs12 sm12 mb-5">
                    <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <v-form ref="editCaseWorker">
            <v-container>
                <!-- <v-card flat class="pf-width-100p"> -->
                    <v-card-text class="px-3">
                        <h5>Please Fill The Below Fileds to Add a Caseworker</h5>
                        <v-layout wrap center class="pb-4 pt-3">
                            <v-flex>
                                <v-layout wrap>
                                    <v-flex xs12 sm4>
                                        <v-text-field label="Firstname" v-model.trim="caseWorkerData.first_name"
                                            class="required pr-4 pl-4" :rules="[rules.required]" @input="changedData"
                                            required>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field label="Lastname" v-model.trim="caseWorkerData.last_name"
                                            class="pr-4 pl-4" @input="changedData"
                                            ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field label="Username" v-model.trim="current_username"
                                             class="pr-4 pl-4" @change="duplicateUserNameChecking"
                                             @input="changedData" browser-autocomplete="new-username"
                                           ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                      <v-text-field 
                                            label="Password" browser-autocomplete="new-password"
                                            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                            @click:append="showPassword = !showPassword"
                                            :type="showPassword ? 'text' : 'password'"
                                            v-model.trim="current_password"
                                            class="pl-4"
                                            @input="changedData"
                                        >
                                        
                                        </v-text-field>
                                       
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field label="Email Address" v-model.trim="caseWorkerData.email"
                                            :rules="[rules.required, rules.emailRules]" v-validate="'required'"
                                            class="required pr-4 pl-4" @input="changedData" @change="duplicateEmailChecking"
                                            required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field label="Phone" v-mask="'(###) ###-####'" placeholder="(###) ###-####"
                                            v-model.trim="caseWorkerData.phone" :rules="[rules.required, rules.phoneRules]"
                                            class="required pr-4 pl-4" @input="changedData" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4>
                                        <v-text-field label="Website" v-model.trim="caseWorkerData.website"
                                            :rules="rules.websiteRules" class="required pr-4 pl-4"
                                            @input="changedData" required></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap class="pr-4 pl-4">
                            <v-flex xs12 class="button-container pr-0 text-xs-right">
                                <div class="d-inline-flex" v-if="selectedData">
                                    <v-btn class="pf-btn pf-btn-cancel" to="/agency/account" @click="selectedData = false">
                                        <v-icon size="16" class="pr-1">cancel</v-icon>
                                        <div>Cancel</div>
                                    </v-btn>
                                    <v-btn class="pf-btn pf-btn-save" @click="save">
                                        <v-icon size="16" class="pr-1">check_circle</v-icon>
                                        <div>Save</div>
                                    </v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                <!-- </v-card> -->
            </v-container>
        </v-form>
    </div>
</template>
  
<script>
/* global session router store config */
import { update, getCollection, validateUrl, checkIfNoPFUrl, request, isEmailValid  } from '../../../helpers/helpers';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';

// To add new countries by the admin
export default {
  name: 'AddCaseWorker',
  directives: { mask },
  data: () => ({
    entity: 'CaseWorker',
    newCaseWorker: {
      first_name: '',
      last_name: '',
      email: '',
      username: '',
      password: '',
      phone: '',
      website: ''
    },
    config: config,
    rules: {
      required: value => !!value || 'Field is required.',
      blankRules: (v) => !!v && v.trim().length > 0 || 'Field is required',
      emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter valid email address',
      zipRules: (v) => v === undefined || v === '' || /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
      phoneRules: (v) => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
      websiteRules: [
        (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL',
        v => !v || checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
      ]
    },
    loading: false,
    selectedData: false,
    usernameFlag: false,
    emailFlag: false,
    caseWokerId: '',
    caseWorkerData: {},
    showPassword: false,
    current_password: '',
    current_username: '',
  }),
  computed: {
    ...mapGetters(['Agency']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
  }, 
  created () {
    this.initialize();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Edit');
  },
  methods: {
    async initialize () {
      this.caseWokerId = this.$route.params && this.$route.params.id ? this.$route.params.id : null;
      let where = { '_id': this.caseWokerId };
      let populate = [{ path: 'user', select: 'username' }];
      let { error, data } = await getCollection(this.entity, true, 0, populate, where, null, null);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.caseWorkerData = data[0];
          this.current_username = data[0].user.username;
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/agency/account' });
    },
    async duplicateEmailChecking () {
      if (this.caseWorkerData.email && isEmailValid(this.caseWorkerData.email)) {
        const emailUrl = `User/EmailCheck/${this.caseWorkerData.email}`;
        let { error, data } = await request(emailUrl, 'GET', {}, null, null);
        if (error === 'Email address exists') {
          console.log(error);
          swal.fire({
            title: 'The email already exists',
            type: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Close',
            allowOutsideClick: false    
          }).then((result) => {
            this.caseWorkerData.email = '';
          });
        } else {
          this.emailFlag = true;
        }
        
      }
    },
    async duplicateUserNameChecking () {
      this.usernameFlag = false;
      if (this.current_username && this.current_username.length) {
        const usernameUrl = `User/UsernameCheck/${this.current_username}`;
        const response = await request(usernameUrl, 'GET', {}, null, null);
        if (response.error === 'Username exists') {
          console.log(response.error);
          swal.fire({
            title: 'The username already exists',
            type: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Close',
            allowOutsideClick: false
          }).then((result) => {
            this.current_username = '';
          });
        } else {
          this.usernameFlag = true;
        }
      }
    },
    async save () {
      if (this.$refs.editCaseWorker.validate()) {
        this.hideButtons();
        let name = this.caseWorkerData.first_name + ' ' + this.caseWorkerData.last_name;
        this.caseWorkerData.name = name;
        if (this.current_password && this.current_password.length) {
          this.caseWorkerData.user['password'] = this.current_password;
        }
        this.caseWorkerData.user['username'] = this.current_username;
        let { error, data, status } = await update('CaseWorker', this.caseWorkerData, this.caseWokerId);
        if (error) {
          swal.fire({
            type: 'warning',
            title: '<b>Error</b>',
            html: data.message,
            showConfirmButton: false,
            timer: 2500
          });
        } else {
          swal.fire({
            type: 'success',
            title: 'Details saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/agency/account' });
            }
          });
        }
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Agencies/CaseWorker/editCaseWorker.vue